// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as PilotDragPanel$LiteracyplanetTupperware from "../v3/PilotDragPanel.res.mjs";

function SkilfulDragPanelSticky$Skilful(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulDragPanelSticky.className
            }, props.children);
}

var Skilful = {
  make: SkilfulDragPanelSticky$Skilful
};

function SkilfulDragPanelSticky(props) {
  var children = props.children;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  if (Curry._1(hasFlag, {
          NAME: "Unleash",
          VAL: "temp_hasPilotLayout"
        })) {
    return React.createElement(PilotDragPanel$LiteracyplanetTupperware.make, {
                children: children
              });
  } else {
    return React.createElement(SkilfulDragPanelSticky$Skilful, {
                children: children
              });
  }
}

var make = SkilfulDragPanelSticky;

var $$default = SkilfulDragPanelSticky;

export {
  Skilful ,
  make ,
  $$default as default,
}
/* react Not a pure module */
